import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';

const Navbar = ({icon, title}) => {
    
    return (
        <nav className='navbar bg-primary'>
            <h1>
            <span className='material-icons'>{icon}</span>
                <i className='fab fa-github'>{title}</i>
            </h1>
            <ul>
                <li>
                    <Link to="/">Home</Link>
                </li>
                <li>
                    <Link to="/about">About</Link>
                </li>
            </ul>

        </nav>
    )    
}

Navbar.defaultProps = {
    title: 'Github Finder',
    icon: 'home'
};

Navbar.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired
};

export default Navbar
